import api from './api';

export const listFeed = (sort = 'recent') =>
  api.get(`/community/posts?sort=${sort}`).then(r => r.data.posts);

export const searchFeed = (q) =>
  api.get(`/community/posts/search?q=${encodeURIComponent(q)}`).then(r => r.data.posts);

export const getPost = (id) =>
  api.get(`/community/posts/${id}`).then(r => r.data);

export const createPost = (fields) =>
  api.post('/community/posts', fields).then(r => r.data.post);

export const deleteOwnPost = (id) =>
  api.delete(`/community/posts/${id}`);

export const createComment = (postId, body, parentCommentId, image_url) =>
  api.post(`/community/posts/${postId}/comments`, { body, parentCommentId, image_url }).then(r => r.data.comment);

export const deleteOwnComment = (commentId) =>
  api.delete(`/community/comments/${commentId}`);

export const reactToPost = (postId, type) =>
  api.post(`/community/posts/${postId}/react`, { type }).then(r => r.data.reactions);

export const reactToComment = (commentId, type) =>
  api.post(`/community/comments/${commentId}/react`, { type }).then(r => r.data.reactions);

export const getUnreadCount = () =>
  api.get('/community/unread').then(r => r.data.count);

export const markHiveViewed = () =>
  api.post('/community/mark-viewed');

// ─── Pictures and videos (Jenn, 2026-10-24) ──────────────────────────────────

/** Uploads one picture or video for a post/comment. Returns { id, kind, url, duration_seconds }. */
export const uploadMedia = (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  // Clear the shared JSON Content-Type so the browser sets multipart with its boundary.
  return api.post('/community/media', formData, {
    headers: { 'Content-Type': undefined },
    timeout: 0,
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100)); },
  }).then(r => r.data.media);
};

/** media = [{ id, alt_text }] in display order. */
export const createCommentWithMedia = (postId, body, parentCommentId, media, contestId = null) =>
  api.post(`/community/posts/${postId}/comments`, { body, parentCommentId, media, contest_id: contestId }).then(r => r.data.comment);

// Team365 — Hive Library
export const listHiveLibrary = ({ kind = 'video', due = false, offset = 0 } = {}) =>
  api.get(`/community/library?kind=${kind}&due=${due ? 1 : 0}&offset=${offset}`).then(r => r.data);

export const keepHiveMedia = (id) => api.post(`/community/library/${id}/keep`).then(r => r.data);

export const deleteHiveMedia = (id) => api.delete(`/community/library/${id}`).then(r => r.data);

// Contests (Jenn, 2026-10-24) — members-only contests running today.
export const getRunningContests = () => api.get('/community/contests/running').then(r => r.data.contests);
